module.exports = __webpack_public_path__ + "static/irstrat3-a7864a665fe895e4d703e21fb87e21bb.jpg";